export enum AppCodeException {
    // Auth
    USER_EMAIL_NOT_FOUND = '10',
    ACCOUNT_DELETED = '11',
    BAD_CREDENTIAL = '12',
    APP_BEARER_TOKEN_NOT_FOUND = '15',
    APP_BEARER_TOKEN_INVALID = '16',
    EXPIRED_TOKEN = '19',
    TOKEN_UNREGISTERED = '19C',

    ACCOUNT_ALREADY_EXIST = '13',
    UNKNOWN = 'UNKNOWN',
    USER_NOT_FOUND = '17',
    USER_EMAIL_ALREADY_EXIST = '19A',
    USERNAME_ALREADY_EXIST = '19B',


    REFRESH_TOKEN_INVALID = '19D',
    REFRESH_TOKEN_EXPIRED = '19E',
    REFRESH_TOKEN_REUSE_DETECTED = '19F',

    /**
     * ⚠️ **Ces quatre-là étaient DÉCALÉS D'UN CRAN.** Le back a inséré
     * `CSRF_INVALID_ORIGIN = '19G'` sans que cette liste suive : depuis, un rejet
     * CSRF s'affichait « Vérifie ton adresse email », une adresse non confirmée
     * s'affichait « lien de réinitialisation invalide », un lien invalide
     * s'affichait « lien expiré », et un lien expiré tombait en « Internal
     * Server Error ». Quatre messages faux, aucun plantage — personne ne pouvait
     * le voir. Un test de structure verrouille désormais la correspondance.
     */
    CSRF_INVALID_ORIGIN = '19G',
    EMAIL_NOT_VERIFIED = '19H',
    RESET_TOKEN_INVALID = '19I',
    RESET_TOKEN_EXPIRED = '19J',

    CLIENT_ERROR = -1,
    CLIENT_TOKEN_EXPIRED = 'TOKEN_EXPIRED',
    CLIENT_TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
    IDENTITY_NO_FOUND = '80',

    ARTICLE_NOT_FOUND = "ART_1",

    CRITERIA_ALREADY_EXIST = "prc_1",
    CRITERIA_NOT_FOUND = "prc_2",

    PROFILE_NOT_FOUND = "pr_2",
    /** Ce domaine est déjà déclaré sur ce profil. */
    DOMAIN_ALREADY_REGISTERED = "pr_3",
    /** Plafond de domaines atteint pour ce profil. */
    DOMAIN_LIMIT_REACHED = "pr_4",
    /** L'adresse saisie n'est pas une URL exploitable. */
    DOMAIN_INVALID_SOURCE_URL = "pr_5",
    PARTNERSHIP_PROFILE_NOT_FOUND = "par_7",
    PROMOTER_NOT_FOUND = "par_1",
    HAS_NOT_RECEIVE_REPONSE_YET = "par_3",
    CURRENT_PROMOTION_UNFINISHED = "par_2",
    A_GREATHER_CRITERIA_VALUE_EXPECTED = "par_5",
    A_SHORTER_CRITERIA_DURATION_EXPECTED = "par_6",
    /** Le découpage en périodes produirait un prélèvement sous le plancher. */
    PERIOD_BELOW_MIN_CHARGE = "par_22",

    /**
     * Aucune carte valide chez l'acheteur — l'autorisation à zéro euro échoue.
     *
     * ⚠️ Elle écarte l'absence de CARTE, pas l'absence de provision : une
     * prépayée chargée d'un euro passe.
     */
    CARD_AUTHORIZATION_FAILED = "par_23",

    /** Le total dépasse le seuil d'authentification forte, carte non autorisée hors session. */
    STRONG_AUTH_REQUIRED = "par_24",

    /** L'encours de l'acheteur atteint son plafond — jamais son prix. */
    BUYER_EXPOSURE_CEILING_REACHED = "par_25",

    /**
     * Le disjoncteur de la plateforme est ouvert : la vente est coupée.
     *
     * ⚠️ Rien à voir avec l'acheteur — c'est NOTRE taux de litiges. Le lui dire
     * comme un refus personnel serait faux.
     */
    PLATFORM_BREAKER_OPEN = "par_26",
    PURCHASE_CAPACITY_UNAVAILABLE = "par_27",

    ACCEPT_PAYOUT_SETUP_FAILED = "par_19",

    /**
     * Le partenariat porte déjà une annulation. Une lecture FRAÎCHE l'aurait
     * annoncée ; celle de la liste vient d'une projection qui peut être en
     * retard, et qui propose alors « Annuler » sur un partenariat clos.
     */
    ALREADY_CANCELED = "par_30",

    /**
     * L'hôte a déjà vingt partenariats en cours. Renvoyé à la DEMANDE comme à
     * l'ACCEPTATION : la vitrine coupe à vingt, et en accepter un de plus
     * encaisserait une diffusion qu'on ne rend pas.
     */
    MAX_RUNNING_REACHED = "par_9",

    // ── Grand livre — étape 13 ────────────────────────────────────────────────
    // ⚠️ Les codes `par_20`, `par_21` et `par_28` ont disparu avec le versement
    // qui les levait : le retrait lit le grand livre, et ses refus lui sont
    // propres.
    /** Rien d'ACQUIS à sortir — le grand livre est vide, ou à zéro. */
    NOTHING_TO_WITHDRAW = "wal_1",
    /**
     * Une contestation bancaire retient le solde. La retenue est PROPORTIONNELLE
     * au montant contesté — ce code ne tombe que lorsqu'il ne reste vraiment rien
     * à verser : retenue totale au-dessus du seuil de litiges, ou retenue qui
     * couvre tout le solde réclamé.
     */
    FROZEN_BY_DISPUTE = "wal_2",
    /** Une sanction court : rien ne sort tant qu'elle n'est pas levée. */
    SANCTIONED = "wal_3",
    /** Le prestataire a refusé le virement. */
    TRANSFER_FAILED = "wal_4",

    // ── Régie publicitaire — étape 14 ────────────────────────────────────────
    /** La provision demandée est sous le plancher de prélèvement. */
    CAMPAIGN_FUNDING_BELOW_MINIMUM = "cam_1",
    /** Aucune campagne de ce compte ne porte cet identifiant. */
    CAMPAIGN_NOT_FOUND = "cam_2",
    /** L'angle poussé n'appartient pas à l'annonceur. */
    CAMPAIGN_ANGLE_NOT_OWNED = "cam_3",
    /** Rien à diffuser : la provision est nulle. */
    CAMPAIGN_NO_PROVISION = "cam_4",
    /**
     * Le compte est masqué par le trust gate — ou sanctionné.
     *
     * ⚠️ « Un hôte a consenti à son partenaire, personne ne consent à une
     * publicité » : l'exception qui protège un partenariat payé ne vaut pas ici.
     */
    CAMPAIGN_ADVERTISER_HIDDEN = "cam_5",
    /** L'état demandé ne s'atteint pas depuis l'état courant. */
    CAMPAIGN_ILLEGAL_TRANSITION = "cam_6",
    /** La fenêtre de diffusion est vide ou déjà passée. */
    CAMPAIGN_INVALID_WINDOW = "cam_7",
    /** Le prestataire a refusé le débit. */
    CAMPAIGN_FUNDING_REFUSED = "cam_8",
    /**
     * L'angle poussé n'a aucun composant diffusable.
     *
     * ⚠️ Distinct du trust gate : là c'est le COMPTE qui ne diffuse pas, ici
     * c'est le CONTENU qui manque.
     */
    CAMPAIGN_NO_SERVABLE_CONTENT = "cam_9",
    /**
     * Un provisionnement est déjà EN COURS sur cette campagne.
     *
     * ⚠️ Ni un refus ni une panne : le verdict d'un débit précédent n'est pas
     * rendu. C'est le seul code du produit dont le message ne doit SURTOUT pas
     * dire « réessaie ».
     */
    CAMPAIGN_FUNDING_IN_FLIGHT = "cam_10",
    /**
     * Cet angle porte déjà une sponsorisation vivante.
     *
     * ⚠️ Rien n'a été débité : ce n'est pas un refus de paiement. Le geste utile
     * n'est pas de réessayer, mais de recharger celle qui existe.
     */
    CAMPAIGN_ANGLE_ALREADY_SPONSORED = "cam_11",

    MEDIA_INVALID_FORMAT = "med_1",

    CATEGORY_NOT_FOUND = "ca_1",
    /**
     * ⚠️ **La MÊME erreur, portée par un second code.** Le module de profil lève
     * le sien quand la catégorie choisie n'existe pas à la mise à jour du profil.
     * Non déclaré ici, ce refus tombait sur le message générique : « Catégorie
     * introuvable » n'était rendu que pour le code du module de catégories.
     */
    PROFILE_CATEGORY_NOT_FOUND = "pr_1",
    CATEGORY_CANNOT_CHANGE_WITH_ACTIVE_PARTNERSHIP = "ca_2",
    CATEGORY_IN_USE = "ca_3",

    FORBIDDEN_ADMIN_ONLY = "90",

    /**
     * Le compte est sanctionné : le jeton reste valide, son porteur ne l'est
     * plus. Le back répond 401 pour que la session soit ÉJECTÉE — un 403
     * laisserait l'écran tourner à vide et une sanction se lirait comme une
     * panne.
     */
    ACCOUNT_REVOKED = "91",

    /** #662 — dernier moyen de paiement actif : suppression refusée par l'API. */
    LAST_PAYMENT_METHOD_UNDELETABLE = "str_24",
    PLAN_CAPABILITY_UNAVAILABLE = "str_25",

    /**
     * #732 — codes d'abonnement que le back renvoie depuis toujours et que le
     * front ne connaissait pas. `TRANSACTION_NOT_FOUND` s'affichait donc en
     * « Internal Server Error » : un rejet métier parfaitement légitime
     * présenté comme une panne serveur, ce qui a envoyé chercher un défaut
     * d'infrastructure là où il n'y en avait aucun.
     */
    CUSTOMER_NOT_FOUND = "str_3",
    PROFILE_ALREADY_SUBSCRIBED = "str_17",
    PROFILE_NOT_SUBSCRIBED = "str_18",
    TRANSACTION_NOT_FOUND = "str_19",
    PROFILE_HAS_PENDING_INVOICE = "str_21",
    MISSING_CLIENT_DOMAIN = "str_23",

    /**
     * Les trois autres refus du chemin d'enregistrement de carte.
     *
     * ⚠️ Sans eux, un refus métier parfaitement explicite retombait sur « Une
     * erreur est survenue, réessaie » — sur l'écran où se joue l'argent, et sur
     * le seul chemin qu'on vient de rouvrir au navigateur.
     */
    STRIPE_SETUP_INTENT_NOT_FOUND = "str_5",
    STRIPE_PAYMENT_METHOD_NOT_FOUND = "str_16",
    PAYMENT_METHOD_BELONGS_TO_ANOTHER_USER = "str_20",

    /**
     * Le mandat n'a pas abouti : l'API refuse d'enregistrer une carte sur la
     * seule parole du navigateur, et relit l'intention chez le prestataire.
     * Arrive quand la banque a refusé ou que le porteur a abandonné le défi.
     */
    SETUP_INTENT_NOT_SUCCEEDED = "str_27",

    /** La carte est là, mais elle ne peut pas être celle qu'on débite. */
    PAYMENT_METHOD_NOT_USABLE = "str_28",

    /** Le prix Business n'a pas pu être établi : on refuse plutôt que de facturer un prix deviné. */
    BUSINESS_PRICE_UNAVAILABLE = "str_29",

    /**
     * Refus de création et de transition côté composant. Sans eux, un rejet
     * métier parfaitement explicite — « tu as déjà exactement ce composant » —
     * s'affichait en « Une erreur est survenue, réessaie », et l'utilisateur
     * n'avait aucun moyen de savoir quoi changer. Le tunnel de duplication tombe
     * sur `COMPONENT_DUPLICATE` par construction si rien n'est modifié.
     */
    COMPONENT_NOT_FOUND = "co_3",
    COMPONENT_DUPLICATE = "co_4",
    COMPONENT_TOO_MANY_VARIATIONS = "co_5",
    VARIATION_TRANSITION_REFUSED = "co_6",
    VARIATION_NOT_FOUND = "co_7",
    ANGLE_NOT_FOUND = "co_8",
    LOCKED_BY_SUBSCRIPTION = "co_9",
    /** Le plafond de contenus du gratuit — deux. */
    COMPONENT_MAX_FREE_REACHED = "co_1",
    /** Le plafond du Business — dix. */
    COMPONENT_MAX_PREMIUM_REACHED = "co_2",
    ANGLE_NAME_REQUIRED = "co_10",

    /** Le guichet de remboursement. */
    REFUND_PURCHASE_NOT_FOUND = "ref_1",
    REFUND_NOTHING_TO_REFUND = "ref_2",
    REFUND_NO_ORIGIN_CHARGE = "ref_3",
    REFUND_SANCTIONED = "ref_4",
    REFUND_IN_FLIGHT = "ref_5",

    /** Capacités vendues — emplacements et grille tarifaire. */
    CAPABILITY_UNKNOWN_PLACEMENT = "cap_1",
    CAPABILITY_UNKNOWN_FORMAT = "cap_2",
    CAPABILITY_UNKNOWN_TIER = "cap_4",
    CAPABILITY_PROFILE_NOT_FOUND = "cap_5",

    /** Trop de tentatives. Le corps porte `retryAfterSeconds`. */
    TOO_MANY_ATTEMPTS = '92',

    /** L'objectif demandé n'est servi par aucun module posé. */
    COMPONENT_OBJECTIVE_NOT_SERVED = 'co_11',
    /** Un libellé qui promet un mécanisme que le geste du composant ne tient pas. */
    COMPONENT_CTA_NOT_IN_CATALOGUE = 'co_12',
    /** Le formulaire désigné n'est pas au compte, ou n'a aucune version publiée. */
    COMPONENT_FORM_NOT_AVAILABLE = 'co_13',
    /**
     * L'objectif demandé n'est servi par aucun moyen du produit — distinct de
     * son voisin, qui parle des moyens que le compte a POSÉS.
     */
    COMPONENT_OBJECTIVE_NOT_OFFERABLE = 'co_14',
}